<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="APR/Graduation/Summary"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs(
        'apr_graduation_summary_external'
      )
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use
      APR/Graduation/Summary (External) Tool.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support (External)
          <i class="fa-solid fa-arrow-right"></i> APR/Graduation/Summary
        </h1>

        <h3 class="h3-second-header">
          Initial results with default form values
        </h3>

        <ul class="unordered-list">
          <li>
            Once you get to the page, results will automatically generate based
            on the default values in the APR/Graduation/Summary form fields.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Goal for APR/Graduation/Summary tool</h3>

        <ul class="unordered-list">
          <li>Analyze the graduation and trends of past years.</li>
          <li>
            The table and charts display trends from cohort 2015 to 2023 for
            APR, retention and degree.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">APR/Graduation/Summary Form Submission</h3>

        <ol class="ordered-list">
          <li>Select a college [Default: All]</li>
          <li>Select a department [Default: All]</li>
          <li>Select a program [Default: All]</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="
              env['logo_paths']['helpPageAprGraduationSummaryFig34External']
            "
            alt=""
          />
          <p class="picture-caption">
            Figure 34: Default inputs for APR/Graduation/Summary form
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Additional APR/Graduation/Summary Form Fields
        </h3>

        <ol class="ordered-list">
          <li>Select a cohort [Default: 2020]</li>
          <li>Select the range for high school GPA [Default: 0 - 5.04]</li>
          <li>Select a demographic [Default: None]</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="small-pics"
            [(src)]="
              env['logo_paths']['helpPageAprGraduationSummaryFig35External']
            "
            alt=""
          />
          <p class="picture-caption">Figure 35: APR/Graduation/Summary Page</p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="
                env['logo_paths']['helpPageAprGraduationSummaryFig36External']
              "
              alt=""
            />
            <p class="picture-caption">
              Figure 36: APR/Graduation/Summary Table Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="
                env['logo_paths']['helpPageAprGraduationSummaryFig37External']
              "
              alt=""
            />
            <p class="picture-caption">
              Figure 37: APR/Graduation/Summary First Graph Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig38']"
              alt=""
            />
            <p class="picture-caption">
              Figure 38: APR/Graduation/Summary Second and Third Graph Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="
                env['logo_paths']['helpPageAprGraduationSummaryFig38aExternal']
              "
              alt=""
            />
            <p class="picture-caption">
              Figure 38a: APR/Graduation/Summary Fourth and Fifth Graph Result
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'APR/Graduation/Summary',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
